import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
// TODO: add back if banner is used
// import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import { useState } from "react";
// TODO: add back if banner is used
// import { useLocation } from "wouter";
// TODO: add back if banner is used
// import Banner from "./Banner";
import { HeaderLinks } from "./HeaderLinks";
import { HeaderLogo } from "./HeaderLogo";
import { MobileNavLinks } from "./MobileLinks";
import { resolveCdnAssetUrl } from "../../utils/cdnAssetUrl";

const GITHUB_LOGO_URL = resolveCdnAssetUrl("logo_github.svg");

export function Header() {
  const [mobileNavOpen, setMobileNavOpen] = useState<boolean>(false);

  // TODO: add block back if banner is used
  // const [location] = useLocation();
  // const isHomePage = location === "/";
  // const [bannerAllowed, setBannerAllowed] = useState<boolean>(isHomePage);
  // useEffect(() => {
  //   if (!isHomePage) {
  //     setBannerAllowed(false);
  //     return;
  //   }
  //   if (mobileNavOpen) {
  //     setBannerAllowed(false);
  //     return;
  //   }
  //   const timeout = setTimeout(() => {
  //     setBannerAllowed(true);
  //   }, 150);

  //   return () => {
  //     clearTimeout(timeout);
  //   };
  // }, [isHomePage, mobileNavOpen]);

  const handleClick = () => {
    setMobileNavOpen((old) => !old);
  };
  const handleClose = () => {
    setMobileNavOpen(false);
  };

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar,
        width: "100%",
      }}
    >
      {/* TODO: add block back if banner is used
      {!mobileNavOpen && (
        // Leave above and useEffect to prevent jarring banner flash when opening mobile nav
        <Slide direction="down" in={bannerAllowed} mountOnEnter unmountOnExit>
          <Box>
            <Banner />
          </Box>
        </Slide>
      )} */}
      <AppBar
        position="static"
        square
        color="transparent"
        sx={{
          py: { sm: 1, md: 2 },
          px: { sm: 2, md: 4 },
          width: "100%",
          background: "var(--mdai-background-header) !important",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            height: "76px",
            color: "#FFF",
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: "16px",
            fontStyle: "normal",
            lineHeight: "145%",
            letterSpacing: "-0.08px",
            maxWidth: 1280,
            width: "100%",
          }}
        >
          <HeaderLogo />
          <HeaderLinks />

          <MobileNavLinks
            isOpen={mobileNavOpen}
            onOpenChange={handleClick}
            handleClose={handleClose}
          />
          <Stack
            direction="row"
            sx={{
              alignItems: "center",
              display: { sm: "none", md: "inline-flex" },
            }}
          >
            <Stack direction={"row"} gap={2} alignItems="center">
              <Link
                href="https://github.com/MyDecisive"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
                sx={{ display: { sm: "none", md: "inline-flex" }, alignItems: "center" }}
              >
                <img alt="GitHub" src={GITHUB_LOGO_URL} style={{ height: "24px" }} />
              </Link>
              <Button
                sx={{ display: { sm: "none", md: "inline-flex" } }}
                variant="contained"
                href={"#schedule-call"}
                onClick={handleClose}
              >
                Contact Sales
              </Button>
            </Stack>
          </Stack>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
